(() => {
  if (customElements.get('vk-equipment-cover')) return;
  class VinkovaEquipmentCover extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-vk-equipment-toggle]');
      this.panel = this.querySelector('[data-vk-equipment-panel]');
      this.grid = this.querySelector('[data-vk-equipment-grid]');
      this.error = this.querySelector('[data-vk-equipment-error]');
      this.addButton = this.querySelector('[data-vk-equipment-add]');
      this.tapeToggle = this.querySelector('[data-vk-tape-toggle]');
      this.tapeSelect = this.querySelector('[data-vk-tape-select]');
      this.catalog = JSON.parse(this.querySelector('[data-vk-equipment-catalog]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-vk-equipment-variants]').textContent);
      this.info = this.closest('product-info') || this.closest('.shopify-section');
      this.form = this.dataset.mode === 'product' ? document.getElementById(this.dataset.formId) : null;
      if (this.dataset.mode === 'product' && !this.form) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.toggle.addEventListener('change', () => this.onToggle(), options);
      this.tapeToggle?.addEventListener('change', () => { this.updateSelection(); this.showError(''); }, options);
      this.tapeSelect?.addEventListener('change', () => { this.selectedTapeId = Number(this.tapeSelect.value); this.updateSelection(); this.showError(''); }, options);
      this.grid.addEventListener('click', event => {
        const button = event.target.closest('[data-equipment-cover-id]');
        if (!button) return;
        this.selectedId = Number(button.dataset.equipmentCoverId);
        this.showError('');
        this.updateSelection();
      }, options);
      this.addButton?.addEventListener('click', () => this.submit(), options);
      this.form?.addEventListener('submit', event => {
        if (!this.toggle.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submit(event.submitter);
      }, { ...options, capture: true });
      this.info?.addEventListener('change', () => queueMicrotask(() => this.updateSelection()), options);
      this.info?.addEventListener('input', () => this.updateSelection(), options);
      this.form?.addEventListener('variant:change', () => this.updateSelection(), options);
      this.render();
      this.refresh().catch(() => {});
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.restorePaymentButtons();
      this.ready = false;
    }

    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency || 'EUR', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    }

    discounted(cover) { return this.catalog.cart.blocked ? cover.price : cover.price - Math.round(cover.price * 0.2); }
    selected() { return this.covers.find(cover => cover.id === this.selectedId); }
    selectedTape() { return this.tapes?.find(tape => tape.id === this.selectedTapeId); }
    quantity() { return this.form ? Math.max(1, Number(new FormData(this.form).get('quantity') || 1)) : 1; }

    eligible() {
      return this.dataset.mode === 'product' || this.catalog.cart[this.dataset.type] > 0;
    }

    render() {
      this.covers = this.catalog.covers.filter(cover => cover.type === this.dataset.type && cover.stock > cover.inCart);
      if (!this.selected()) this.selectedId = null;
      this.hidden = !this.covers.length || !this.eligible();
      if (this.hidden) this.toggle.checked = false;
      const scroll = this.grid.scrollTop;
      this.grid.replaceChildren(...this.covers.map(cover => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vk-cover__design';
        button.dataset.equipmentCoverId = String(cover.id);
        button.setAttribute('aria-label', cover.title);
        button.title = cover.title;
        const image = this.coverImage(cover);
        button.append(image);
        return button;
      }));
      this.grid.scrollTop = scroll;
      this.querySelector('[data-vk-equipment-more]').hidden = this.covers.length <= 8;
      this.renderTapes();
      this.updateSelection();
      this.updatePanel();
    }

    coverImage(cover) {
      if (cover.crop?.some((value, index) => value !== [0, 0, 100, 100][index])) {
        const image = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const [x, y, width, height] = cover.crop.map((value, index) => value * (index % 2 ? cover.imageHeight : cover.imageWidth) / 100);
        image.setAttribute('viewBox', [x, y, width, height].join(' '));
        image.setAttribute('aria-hidden', 'true');
        const frame = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        Object.entries({ x, y, width, height, overflow: 'hidden' }).forEach(([name, value]) => frame.setAttribute(name, value));
        const source = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        source.setAttribute('href', cover.image);
        source.setAttribute('x', -x);
        source.setAttribute('y', -y);
        source.setAttribute('width', cover.imageWidth);
        source.setAttribute('height', cover.imageHeight);
        frame.append(source);
        image.append(frame);
        return image;
      }
      const image = document.createElement('img');
      image.src = cover.image;
      image.alt = '';
      image.width = 120;
      image.height = 100;
      image.loading = 'lazy';
      return image;
    }

    renderTapes() {
      if (!this.tapeSelect) return;
      this.tapes = (this.catalog.tapes || []).filter(tape => tape.stock > tape.inCart);
      if (!this.selectedTape()) this.selectedTapeId = null;
      this.querySelector('[data-vk-tape-offer]').hidden = !this.tapes.length;
      if (!this.tapes.length) this.tapeToggle.checked = false;
      const placeholder = new Option(this.tapeSelect.dataset.placeholder, '');
      this.tapeSelect.replaceChildren(placeholder, ...this.tapes.map(tape => new Option(`${tape.title} · ${this.money(tape.price)}`, String(tape.id))));
      this.tapeSelect.value = this.selectedTapeId ? String(this.selectedTapeId) : '';
    }

    updateSelection() {
      if (!this.covers) return;
      const selected = this.selected();
      const cover = selected || this.covers[0];
      const tapeEnabled = this.toggle.checked && this.tapeToggle?.checked;
      const tape = tapeEnabled ? this.selectedTape() : null;
      if (this.tapeToggle) {
        this.querySelector('[data-vk-tape-panel]').hidden = !tapeEnabled;
        this.tapeToggle.setAttribute('aria-expanded', String(Boolean(tapeEnabled)));
        const image = this.querySelector('[data-vk-tape-image]');
        image.hidden = !tape;
        if (tape) image.src = tape.image;
      }
      if (cover) {
        const finalPrice = this.discounted(cover);
        const hasDiscount = finalPrice < cover.price;
        const [beforePrice, afterPrice = ''] = this.dataset.offer.split('[price]');
        const price = document.createElement('span');
        price.className = 'vk-cover__current';
        price.textContent = this.money(finalPrice);
        this.querySelector('[data-vk-equipment-offer]').replaceChildren(document.createTextNode(beforePrice), price, document.createTextNode(afterPrice));
        this.querySelector('[data-vk-equipment-comparison]').hidden = !hasDiscount;
        this.querySelector('[data-vk-equipment-original]').textContent = hasDiscount ? this.money(cover.price) : '';
        const saving = this.querySelector('[data-vk-equipment-saving]');
        saving.hidden = !hasDiscount;
        saving.textContent = hasDiscount ? this.dataset.saving.replace('[saving]', this.money(cover.price - finalPrice)) : '';
      }
      this.querySelector('[data-vk-equipment-promotion-note]').hidden = !this.catalog.cart.blocked;
      this.grid.querySelectorAll('[data-equipment-cover-id]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.equipmentCoverId) === this.selectedId)));
      this.querySelector('[data-vk-equipment-selection]').textContent = selected?.title || '';
      if (this.addButton) {
        this.addButton.disabled = !selected || this.submitting;
        if (selected) this.addButton.textContent = this.dataset.add.replace('[price]', this.money(this.discounted(selected)));
      }
      if (this.form) {
        const variant = this.variants.find(item => item.id === Number(this.form.querySelector('[name="id"]')?.value));
        this.querySelector('[data-vk-equipment-total-row]').hidden = this.catalog.cart.blocked || !this.toggle.checked || !selected || (tapeEnabled && !tape);
        if (variant) this.querySelector('[data-vk-equipment-total]').textContent = this.money((variant.price + (selected ? this.discounted(selected) : 0) + (tape?.price || 0)) * this.quantity());
      }
    }

    restorePaymentButtons() {
      this.paymentButtons?.forEach(({ element, hidden }) => { element.hidden = hidden; });
      this.paymentButtons = null;
    }

    updatePanel() {
      this.panel.hidden = !this.toggle.checked;
      this.toggle.setAttribute('aria-expanded', String(this.toggle.checked));
      if (this.form && this.toggle.checked && !this.paymentButtons) {
        this.paymentButtons = Array.from(this.form.querySelectorAll('.shopify-payment-button')).map(element => ({ element, hidden: element.hidden }));
        this.paymentButtons.forEach(({ element }) => { element.hidden = true; });
      } else if (!this.toggle.checked) this.restorePaymentButtons();
      this.updateSelection();
    }

    async onToggle() {
      if (!this.toggle.checked && this.tapeToggle) this.tapeToggle.checked = false;
      this.updatePanel();
      this.showError('');
      if (!this.toggle.checked) return;
      try { await this.refresh(); }
      catch { this.showError(this.dataset.loadError); }
    }

    showError(message) {
      const target = this.hidden && this.form ? this.form.querySelector('.product-form__error-message') || this.error : this.error;
      target.textContent = message;
      target.hidden = !message;
    }

    async refresh() {
      if (this.refreshRequest) return this.refreshRequest;
      this.refreshRequest = this.loadCatalog();
      try { await this.refreshRequest; } finally { this.refreshRequest = null; }
    }

    async loadCatalog() {
      const url = new URL(this.dataset.catalogUrl, location.origin);
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('section_id', 'vinkova-equipment-cover-catalog');
      url.searchParams.set('_vk_refresh', String(Date.now()));
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(this.dataset.loadError);
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = document.querySelector('[data-vk-equipment-catalog]');
        if (!data) throw new Error(this.dataset.loadError);
        const catalog = JSON.parse(data.textContent);
        if (!Array.isArray(catalog.covers) || !catalog.cart || typeof catalog.cart.blocked !== 'boolean') throw new Error(this.dataset.loadError);
        this.catalog = catalog;
        this.render();
      } finally { this.removeAttribute('aria-busy'); }
    }

    async prepare(data) {
      const selectedId = this.selectedId;
      const selectedPrice = this.selected() ? this.discounted(this.selected()) : null;
      const tapeEnabled = Boolean(this.tapeToggle?.checked);
      const selectedTapeId = this.selectedTapeId;
      if (!selectedId) {
        this.grid.querySelector('button')?.focus();
        throw new Error(this.dataset.choose);
      }
      const quantity = this.quantity();
      if (tapeEnabled && !selectedTapeId) {
        this.tapeSelect.focus();
        throw new Error(this.querySelector('[data-vk-tape-error-copy]').textContent);
      }
      await this.refresh();
      if (!this.eligible()) throw new Error(this.dataset.ineligible);
      const cover = this.selected();
      if (!this.toggle.checked || !cover || cover.id !== selectedId || cover.stock < cover.inCart + quantity) throw new Error(this.dataset.unavailable);
      if (this.discounted(cover) > selectedPrice) throw new Error(this.querySelector('[data-vk-equipment-price-changed]').textContent);
      const tape = tapeEnabled ? this.selectedTape() : null;
      if (tapeEnabled && (!this.tapeToggle.checked || !tape || tape.id !== selectedTapeId || tape.stock < tape.inCart + quantity)) throw new Error(this.dataset.unavailable);
      const combined = new FormData();
      let index = 0;
      if (this.form) {
        const current = new FormData(this.form);
        if (current.get('id') !== data.get('id') || this.quantity() !== quantity) throw new Error(this.dataset.loadError);
        for (const [name, value] of data) {
          if (name === 'id' || name === 'quantity' || name === 'selling_plan') combined.append(`items[0][${name}]`, value);
          else if (/^properties\[.+\]$/.test(name)) combined.append(`items[0][properties][${name.slice(11, -1)}]`, value);
          else combined.append(name, value);
        }
        combined.set('items[0][quantity]', String(quantity));
        index = 1;
      }
      combined.set(`items[${index}][id]`, String(cover.id));
      combined.set(`items[${index}][quantity]`, String(quantity));
      if (tape) {
        combined.set(`items[${index + 1}][id]`, String(tape.id));
        combined.set(`items[${index + 1}][quantity]`, String(quantity));
      }
      return combined;
    }

    async submit(submitter) {
      if (this.submitting) return;
      this.submitting = true;
      this.showError('');
      const button = submitter || this.addButton || this.form?.querySelector('[type="submit"]');
      const wasDisabled = button?.disabled;
      button?.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;
      let addedSuccessfully = false;
      try {
        const data = await this.prepare(this.form ? new FormData(this.form) : new FormData());
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
        if (this.dataset.sectionId) sections.push(this.dataset.sectionId);
        data.set('sections', [...new Set(sections)].slice(0, 5).join(','));
        data.set('sections_url', location.pathname);
        const response = await fetch(`${this.dataset.root.replace(/\/$/, '')}/cart/add.js`, { method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        const added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || this.dataset.unavailable);
        addedSuccessfully = true;
        const cartResponse = await fetch(`${this.dataset.root.replace(/\/$/, '')}/cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(this.dataset.loadError);
        const cart = await cartResponse.json();
        cart.sections = added.sections;
        const inCesta = Boolean(this.closest('vk-cesta'));
        const productMode = this.dataset.mode === 'product';
        window.theme?.pubsub?.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added, vk: true } }));
        if (productMode || inCesta) {
          const cesta = document.querySelector('vk-cesta');
          if (cesta?.show(added, added.sections?.[cesta.dataset.sectionId])) return;
          const drawer = document.querySelector('cart-drawer');
          if (drawer?.show) drawer.show(button);
          else location.href = `${this.dataset.root.replace(/\/$/, '')}/cart`;
        }
      } catch (error) {
        if (addedSuccessfully) location.href = `${this.dataset.root.replace(/\/$/, '')}/cart`;
        else this.showError(error.message || this.dataset.loadError);
      } finally {
        this.submitting = false;
        button?.removeAttribute('aria-busy');
        if (button) button.disabled = wasDisabled;
        this.updateSelection();
      }
    }
  }
  customElements.define('vk-equipment-cover', VinkovaEquipmentCover);
})();

